import { createTheme } from '@mui/material/styles'

const ThemeMaterial = createTheme({
  typography: {
    fontFamily: '"Open Sans", sans-serif'
  }
})

export default ThemeMaterial
